import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const HEAR_IT_TYPE_IT_ACTIVITY_FRAGMENT = gql `
  fragment HearItTypeItActivityFragment on HearItTypeItActivity {
    rounds {
      affirmationAudio {
        ...AssetFragment
      }
      answer
      answerAudio {
        audio {
          ...AssetFragment
        }
      }
      answerType
      instructions
      instructionsAudio {
        audio {
          ...AssetFragment
        }
      }
      numberOfAttempts
      hearItTypeItImage: optionalImage {
        image {
          ...AssetFragment
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default HEAR_IT_TYPE_IT_ACTIVITY_FRAGMENT;
